
import { DocumentTypeState } from './types';

export const state = (): DocumentTypeState => initialState();

export const initialState = (): DocumentTypeState => ({
  documentTypes: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['ActionEmailMessage'],
      andClauseFieldsIds: [],
    },
  },
});
